import Bio from "../components/InstructorProfile/Bio"
import Courses from "../components/InstructorProfile/Courses"
import Header from "../components/InstructorProfile/Header"
import { useParams } from 'react-router-dom';
import { GetInstructorById } from "../api/Instructor/GetInstructorById";
import { useQuery } from '@tanstack/react-query'
import Spinner from "../components/Shared/Spinner";

import { Helmet } from 'react-helmet';


const InstructorProfile = () => {

  const { id } = useParams();
  const instructorId = id || "";


  const { data: InstructorByIdDTO, isLoading: isInstructorLoading } = useQuery({
    queryFn: () => GetInstructorById(instructorId),
    queryKey: ["instructor", instructorId],
    staleTime: 0,
    refetchInterval: 0,
  });
  const Instructor = InstructorByIdDTO?.data  ;
  if (isInstructorLoading) return (
    <div className='min-h-screen flex items-center justify-center'>
          <Spinner/>
    </div>
  )
  return (
    <div className="pt-20 container">

      <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/instructor" />
      </Helmet>

      <Header img={Instructor?.photo} firstName={Instructor?.firstName} lastName={Instructor?.lastName} university={Instructor?.university}/>
      <Bio bio={Instructor?.bio}/>
      <Courses instructor={Instructor} />
    </div>
  )
}

export default InstructorProfile